var link_viewer_default = {
  "fontElementMap": "DtN5X",
  "link": "p0voE",
  "linkInEditor": "k90ua",
  "linkInViewer": "XhQT4",
  "toolbarUrlContainer": "iQrsZ",
  "toolbarUrl": "_7x0Mw",
  "toolbarUrlAnchor": "K9l6h"
};
export {
  link_viewer_default as default
};
//# sourceMappingURL=link-viewer-scss.js.map
